<template>
  <el-card class="box-card">
    <el-row>
      <el-col class="fs-bd-b pb-2">
        <p class="text-heading2--med ma--0">{{ $t('drawer.editorder.order') }} #{{ historylist.orderCode }}</p>
        <label class="font-green text-heading3--bold" v-if="historylist.deliveryStatus == 8">{{ $t('pageOrderListHistory.success') }}</label>
        <label class="font-red text-heading3--bold" v-else>{{ $t('pageOrderListHistory.cancel') }}</label>
        <label class="text-heading3 cl-gray-ligth" v-if="historylist.deliveryStatus == 8">{{ historylist.receiveDt }}</label>
        <label class="text-heading3 cl-gray-ligth" v-else>{{ historylist.cancelTime }}</label>
        <br><label class="text-heading3 cl-back-ligth" v-if="historylist.rejectReason != '' && historylist.rejectReason == 'ร้านปิด'">{{ $t('pageOrderListHistory.note') }}: {{ ($i18n.locale === 'en') ? 'Closed' : historylist.rejectReason }}</label>
        <label class="text-heading3 cl-back-ligth" v-if="historylist.rejectReason != '' && historylist.rejectReason == 'รายการสินค้าหมด'">{{ $t('pageOrderListHistory.note') }}: {{ ($i18n.locale === 'en') ? 'Out of stock' :  historylist.rejectReason }}</label>
        <label class="text-heading3 cl-back-ligth" v-if="historylist.rejectReason != '' && historylist.rejectReason == 'งดส่งชั่วคราว'">{{ $t('pageOrderListHistory.note') }}: {{ ($i18n.locale === 'en') ? 'Temporarily closed' :  historylist.rejectReason }}</label>
        <label class="text-heading3 cl-back-ligth" v-if="historylist.rejectReason != '' && historylist.rejectReason.search('อื่นๆ') != -1">{{ $t('pageOrderListHistory.note') }}: {{ ($i18n.locale === 'en') ? historylist.rejectReason.replace("อื่นๆ", "Etc") : historylist.rejectReason }}</label>
      </el-col>
    </el-row>
    <el-row>
      <el-col class="mt-2 fs-of-address" v-if="historylist.orderTypeDesc == 'Delivery'">
        <label class="text-heading3--bold cl-gray-ligth">
          <i class="el-icon-location"></i> {{ $t('pageOrderListHistory.delivery') }}
        </label>
        <label class="text-heading3 ml--2">{{ historylist.address }}</label>
      </el-col>
      <el-col class="mt-2 fs-of-address" v-else>
        <img width="20" src="@/assets/icons/pickup_inactive.png"/>
        <label class="text-heading3--bold cl-gray-ligth">{{ $t('pageOrderListHistory.pickup') }}</label>
        <label class="text-heading3 ml--2" v-if="historylist.branchName == '' || historylist.branchName === null">{{ historylist.restaurantName }}</label>
        <label class="text-heading3 ml--2" v-else>{{ historylist.restaurantName }} {{ $t('pageCheckout.branch') }} {{ historylist.branchName }}</label>
      </el-col>
      <el-col class="fs-image-icon fs-bd-b py-1">
        <el-row>
          <el-col v-bind:class="(index == 4) ? '' : 'mr-14'" v-for="(menu, index) in historylist.menus" :key="index" :span="4">
            <el-image
              v-if="index < 4"
              class="image"
              :fit="'cover'"
              :src="'https://images.foodstory.co/' + menu.image_key"
              :preview-src-list="srcList"
              :alt="'menu-detail'"
            />
            <div v-if="index == 4" class="fs-image-icon-more" @click="viewMoreImgae(historylist.menus)">
              <span>+{{ historylist.menus.length }}</span>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col>
        <el-row class="py-1">
          <el-col :span="12" class="text-left">
            <label class="text-title--large">
              {{ $t('pageCheckout.subtotal') }}:
              {{ historylist.totalAmount | priceFormat(0,$store.getters.currency) }}
            </label> 
          </el-col>
          <el-col :span="12" class="text-right">
            <label class="fs-link text-link" @click="togglePaid">{{ $t('pageOrderListCurrent.moredetail') }}</label>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>
import Mixins from '@/utils/mixins'
export default {
  name: 'OrderListHistory',
  props: ['historylist'],
  data () {
    return {
      srcList: [],
      Today: new Date()
    }
  },
  mixins: [Mixins],
  mounted () {
    this.srcList = []
    this.historylist.menus.forEach(element => {
      this.srcList.push('https://images.foodstory.co/' + element.image_key)
    })
  },
  methods: {
    viewMoreImgae (menu) {
      this.srcList = []
      menu.forEach(element => {
        this.srcList.push('https://images.foodstory.co/' + element.image_key)
      })
      this.$emit('toggle_all_image', this.srcList)
    },
    togglePaid () {
      this.$emit('toggle_piad', this.historylist)
    },
    getTime (date) {
      let dateParameter = new Date(date)
      return ('0' + dateParameter.getHours()).slice(-2) + ':' + (dateParameter.getMinutes() < 10 ? '0' : '') + dateParameter.getMinutes()
    }
  },
  computed: {
    BranchDetail () {
      return this.$store.getters.BranchDetail
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/order/OrderListHistory.vue